"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var services_1 = require("@nw/ui-core-shared/services");
var main_store_service_1 = require("@nw/ui-core-shared/store/main-store.service");
var DealerblockBuyNowV1Component = (function () {
    function DealerblockBuyNowV1Component(environmentService, window, mainStoreService) {
        this.environmentService = environmentService;
        this.window = window;
        this.mainStoreService = mainStoreService;
        this.lang = 'en';
    }
    DealerblockBuyNowV1Component.prototype.ngOnInit = function () {
        var _this = this;
        this.mainStoreService.getStore().select(function (state) { return state.appPrincipal; })
            .subscribe(function (principal) {
            _this.lang = principal.language ? principal.language : 'en';
        });
        this.buyerOaUrl = this.environmentService.getEnvironment().interfacePath.buyerOa;
        this.buyNowUrl = this.buyerOaUrl + "/buyDetails.html?vehicleId=" + this.originalVehicleId;
    };
    DealerblockBuyNowV1Component.prototype.navigateToClassic = function () {
        this.window.open(this.buyNowUrl, '_self');
    };
    return DealerblockBuyNowV1Component;
}());
DealerblockBuyNowV1Component.decorators = [
    { type: core_1.Component, args: [{
                selector: 'nw-dealerblock-buy-now-v1',
                template: "<div *ngIf=\"allowBuyNow && !isPreviewProxy\">\n  <button data-a8n=\"db-buy-now\" class=\"btn btn-block btn-v1-primary-5-white-teal wrap-content\" (click)=\"navigateToClassic()\">{{ 'dealerBlockLayout.buyNow' | translate}} {{ buyNowPrice | nwCurrency: lang }}</button>\n </div>\n<div *ngIf=\"allowBuyNow && isPreviewProxy\">\n    <button data-a8n=\"db-watchlist-preview-proxy-buy-now\" class=\"btn btn-block btn-v1-primary-5-white-teal wrap-content\" (click)=\"navigateToClassic()\">{{ 'dealerBlockLayout.buyNow' | translate}} {{ buyNowPrice | nwCurrency: lang }}</button>\n</div>\n",
                styles: [""]
            },] },
];
/** @nocollapse */
DealerblockBuyNowV1Component.ctorParameters = function () { return [
    { type: services_1.EnvironmentService, },
    { type: undefined, decorators: [{ type: core_1.Inject, args: ['windowObject',] },] },
    { type: main_store_service_1.MainStoreService, },
]; };
DealerblockBuyNowV1Component.propDecorators = {
    'allowBuyNow': [{ type: core_1.Input },],
    'buyNowPrice': [{ type: core_1.Input },],
    'originalVehicleId': [{ type: core_1.Input },],
    'isPreviewProxy': [{ type: core_1.Input },],
};
exports.DealerblockBuyNowV1Component = DealerblockBuyNowV1Component;
//# sourceMappingURL=dealerblock-buy-now-v1.component.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nw/dealerblock-bid-ui/components/components-v1/dealerblock-buy-now-v1/dealerblock-buy-now-v1.component.js
// module id = lhRy
// module chunks = 0